exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".activity---1THe9{width:calc(100% - 275px);margin:0 5px 0 40px;background-color:#fff;border-radius:16px;position:relative}.activity---1THe9.completed---2FdXo{background-color:#fffaff}.activity---1THe9 .inner-scroll---J442S{overflow-y:auto;padding:30px 34px;width:100%;height:100%;position:absolute}.activity---1THe9 .inner-scroll---J442S.completed---2FdXo{overflow:hidden}.activity---1THe9 .tri---2dQKL{position:absolute;right:0;bottom:0;transform:translate(0, 100%)}@media only screen and (max-width: 800px){.activity---1THe9{width:100%;margin:0 40px}}", ""]);

// exports
exports.locals = {
	"activity": "activity---1THe9",
	"completed": "completed---2FdXo",
	"inner-scroll": "inner-scroll---J442S",
	"tri": "tri---2dQKL"
};